/**
 * Created by joyce on 2021/8/14.
 */
 import React from 'react';
 import PropTypes from 'prop-types';
 import { Popover, Menu } from 'antd';
 import './style.less';
 
 class DmsTab extends React.Component {
   constructor (props) {
     super(props);
     this.state = {
       visible: false,
     }
     this.clickHandle = this.clickHandle.bind(this);
     this.changeHandle = this.changeHandle.bind(this);
   }
 
   clickHandle ({ item, key, keyPath }) {
     this.setState({ visible: false });
     if (this.props.onChange && typeof  this.props.onChange === 'function') {
       this.props.onChange({ item, key, keyPath });
     }
   }
 
   changeHandle (visible) {
     this.setState({ visible })
   }
 
   render () {
     const { defaultKey, options, className } = this.props;
     const content = options.length > 1 ? <Menu
       onClick={this.clickHandle}
       style={{ margin: '-8px -16px' }}>
       {
         options.map((item, index) => <Menu.Item key={index}>{item}</Menu.Item>)
       }
     </Menu> : null;
     let filterBox = []; //存储筛选框（FilterBox组件）
     let children = null;
     if (this.props.children) {
       children = Array.isArray(this.props.children) ? [...this.props.children] : { ...this.props.children };
     }
     if (Array.isArray(children)) { //提取FilterBox
       for (let n = 0; n < children.length; n++) {
         if (children[n] && children[n].props && children[n].props.hasOwnProperty('componentName') && children[n].props.componentName === 'FilterBox') {
           filterBox = children.splice(n, 1);
           break;
         }
       }
     }
     /*if (Array.isArray(this.props.children)) { //将FilterBox组件放到dms-tab-btn外面
      var newChildren = this.props.children.slice(0, this.props.children.length);
      var child = [];
      for (var n = 0; n < newChildren.length; n++) {
      if (newChildren[n] && newChildren[n].type && newChildren[n].type.name == 'FilterBox') {
      child = newChildren.splice(n, 1);
      break;
      }
      }
      }*/
     return <div className={className ? `dms-tab-bar ${className}` : "dms-tab-bar"}>
       {
         options.length > 1 ? <Popover style={{ marginTop: '3px' }}
                                       placement="bottom"
                                       title={null}
                                       visible={this.state.visible}
                                       content={content}
                                       onVisibleChange={this.changeHandle}
                                       trigger="click">
           <div className={options.length > 1 ? "dms-tab-name v-line arrow-down" : "dms-tab-name v-line"}>
             {options[defaultKey]}
           </div>
         </Popover> :
           <div className={options.length > 1 ? "dms-tab-name v-line arrow-down" : "dms-tab-name v-line"}>
             {options[defaultKey]}
           </div>
       }
       {filterBox}
       {
         children ? <div className="dms-tab-btn">
           {
             children
           }
         </div> : null
       }
     </div>
   }
 }
 DmsTab.propTypes = {
   defaultKey: PropTypes.number.isRequired,
   options: PropTypes.array.isRequired,
   onChange: PropTypes.func,
 };
 export default DmsTab;